import List from './components/List'

const ProcessModules = {
    List,
}
export default ProcessModules
